import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { PerkTag } from "store/apis/perksCrm";

type TagChipProps = {
  tag: PerkTag;
  onRemove?: (tagId: string) => void;
};

export const TagChip = ({ tag, onRemove }: TagChipProps) => {
  const handleRemove = () => onRemove?.(tag.uuid);

  return (
    <span
      className="t-inline-flex t-items-center t-gap-1 t-rounded t-px-2 t-py-0.5 t-text-body-sm"
      style={{ color: tag.color_hex, backgroundColor: tag.bg_color_hex }}
    >
      #{tag.title}
      {onRemove && (
        <Button
          type="button"
          customType="ghost_icon"
          size="xsmall"
          onClick={handleRemove}
          aria-label="Remove tag"
        >
          <Cross size="12" color={tag.color_hex} />
        </Button>
      )}
    </span>
  );
};
